module.exports = __webpack_public_path__ + "r-v3/img/arrowBack.df782d6c.svg";